import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Meta from 'vue-meta'

// views
import Setup from '@/views/Setup'
import SetupPassword from '@/views/SetupPassword'
import Signin from '@/views/Signin'
import Verification from '@/views/Verification'
import NotFound from '@/views/NotFound'
import DashBoard from '@/views/DashBoard'

// ---------------
// サービス管理
// ---------------
// Service
import Service from '@/views/Service'
import ServiceForm from '@/views/Service/Form'
import ServiceInput from '@/views/Service/Form/Input'
import ServiceConfirm from '@/views/Service/Form/Confirm'
import ServiceDetail from '@/views/Service/Detail'
// Service : DeliveryTerm
import ServiceDeliveryTerm from '@/views/Service/DeliveryTerm'
import ServiceDeliveryTermDetail from '@/views/Service/DeliveryTerm/Detail'
// Service : Attribute
import ServiceAttribute from '@/views/Service/Attribute'
import ServiceAttributeDetail from '@/views/Service/Attribute/Detail'
// Service : Function
import ServiceFunction from '@/views/Service/Function'
import ServiceFunctionDetail from '@/views/Service/Function/Detail'
// Service : MailMagazine
import ServiceMailMagazine from '@/views/Service/MailMagazine'
// Service : LinkedCms
import ServiceLinkedCms from '@/views/Service/LinkedCms'
// Service : Rss
import ServiceRss from '@/views/Service/Rss'
// Service : Dropbox
import ServiceDropbox from '@/views/Service/Dropbox'
// Service : ContentsSetting
import ServiceContentsSetting from '@/views/Service/ContentsSetting'
import ServiceContentsSettingForm from '@/views/Service/ContentsSetting/Form'
import ServiceContentsSettingInput from '@/views/Service/ContentsSetting/Form/Input'
// Service : ScreenSetting
import ServiceScreenSetting from '@/views/Service/ContentsSetting/ScreenSetting'
import ServiceScreenSettingForm from '@/views/Service/ContentsSetting/ScreenSetting/Form'
import ServiceScreenSettingInput from '@/views/Service/ContentsSetting/ScreenSetting/Form/Input'
// Service : ContentsApply
import ServiceContentsApply from '@/views/Service/ContentsApply'

// Service : File
import File from '@/views/File'

// Service : Bot
import Bot from '@/views/Bot'

// 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
// Service : Partner
import Partner from '@/views/Partner'
import PartnerForm from '@/views/Partner/Form'
import PartnerInput from '@/views/Partner/Form/Input'
import PartnerConfirm from '@/views/Partner/Form/Confirm'
// 202304 サービス管理に「外部パートナー連携」メニューを追加 ED

// ---------------
// マスタ管理
// ---------------
import DeliveryTypeMst from '@/views/DeliveryTypeMst'
import NoticeTypeMst from '@/views/NoticeTypeMst'
import LinkedCmsMst from '@/views/LinkedCmsMst'
import ScreenConfigMst from '@/views/ScreenConfigMst'
import ScreenIdMst from '@/views/ScreenIdMst'
import SpAppMst from '@/views/SpAppMst'

// ---------------
// アカウント管理
// ---------------
import User from '@/views/User'
import UserForm from '@/views/User/Form'
import UserInput from '@/views/User/Form/Input'
import UserConfirm from '@/views/User/Form/Confirm'

// ---------------
// お知らせ管理
// ---------------
import Notice from '@/views/Notice'
import NoticeForm from '@/views/Notice/Form'
import NoticeSelector from '@/views/Notice/Form/Selector'
import NoticeInput from '@/views/Notice/Form/Input'
import NoticeConfirm from '@/views/Notice/Form/Confirm'
import NoticeDetail from '@/views/Notice/Detail'

// ---------------
// ログ管理
// ---------------
import Log from '@/views/Log'
import LogDownload from '@/views/Log/Download'

// ---------------
// ADMP管理
// ---------------
import Tenant from '@/views/Tenant'
import TenantDetail from '@/views/Tenant/Detail'
import Community from '@/views/Community'
import CommunityDetail from '@/views/Community/Detail'
import CommunityLocation from '@/views/Community/Location'
import Device from '@/views/Device'

// ---------------
// ささえiでんわ管理
// ---------------
import VideoChat from '@/views/VideoChat'

// ---------------
// お知らせ配信管理
// ---------------
import NoticeCheck from '@/views/NoticeCheck'

// ---------------
// Core
// ---------------
// views : MyAccount
import MyAccount from '@/views/MyAccount'

// // view : Register
// import Register from '@/views/Register'
// import RegisterInput from '@/views/Register/Input'
// import RegisterConfirm from '@/views/Register/Confirm'

// view : Password
import Password from '@/views/Password'
import PasswordInput from '@/views/Password/Input'
import PasswordConfirm from '@/views/Password/Confirm'

// ---------------
// ロケーション管理
// ---------------
import Location from '@/views/Location'

// utils
import Constants from '@/utils/Constants'

Vue.use(Router)
Vue.use(Meta)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // リダイレクト
    // { path: '/myAccount', redirect: '/myAccount/form'},

    // ダッシュボード
    {
      path: '/home',
      name: 'Home',
      component: DashBoard,
      meta: { requiresAuth: true }
      // redirect: { name: 'User' }
    },

    // ---------------
    // サービス管理
    // ---------------

    // サービス一覧
    {
      path: '/service',
      name: 'Service',
      component: Service,
      meta: { requiresAuth: true }
    },
    // サービス登録・編集
    {
      path: '/service/:serviceId',
      component: ServiceForm,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true },
      children: [
        // 入力
        {
          path: 'form',
          name: 'ServiceForm',
          component: ServiceInput
        },
        // 確認
        {
          path: 'confirm',
          name: 'ServiceConfirm',
          component: ServiceConfirm
        }
      ]
    },
    // サービス詳細
    {
      path: '/service/:serviceId/detail',
      name: 'ServiceDetail',
      component: ServiceDetail,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },

    // 配信期間設定
    {
      path: '/service/:serviceId/deliveryTerm',
      name: 'ServiceDeliveryTerm',
      component: ServiceDeliveryTerm,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },
    // 配信期間設定 : 詳細
    {
      path: '/service/:serviceId/deliveryTerm/:deliveryTypeId/detail',
      name: 'ServiceDeliveryTermDetail',
      component: ServiceDeliveryTermDetail,
      props: route => ({
        serviceId: route.params.serviceId,
        deliveryTypeId: route.params.deliveryTypeId
      }),
      meta: { requiresAuth: true }
    },

    // 属性設定
    {
      path: '/service/:serviceId/attribute',
      name: 'ServiceAttribute',
      component: ServiceAttribute,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },
    // 属性設定 : 詳細
    {
      path: '/service/:serviceId/attribute/:attributeTypeId/detail',
      name: 'ServiceAttributeDetail',
      component: ServiceAttributeDetail,
      props: route => ({
        serviceId: route.params.serviceId,
        attributeTypeId: route.params.attributeTypeId
      }),
      meta: { requiresAuth: true }
    },

    // 機能設定
    {
      path: '/service/:serviceId/function',
      name: 'ServiceFunction',
      component: ServiceFunction,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },
    // 機能設定 : 詳細
    {
      path: '/service/:serviceId/function/:functionId/detail',
      name: 'ServiceFunctionDetail',
      component: ServiceFunctionDetail,
      props: route => ({
        serviceId: route.params.serviceId,
        functionId: route.params.functionId
      }),
      meta: { requiresAuth: true }
    },

    // メルマガ設定
    {
      path: '/service/:serviceId/mailMagazine',
      name: 'ServiceMailMagazine',
      component: ServiceMailMagazine,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },
    // 連携CMS設定
    {
      path: '/service/:serviceId/linkedCms',
      name: 'ServiceLinkedCms',
      component: ServiceLinkedCms,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },
    // RSS設定
    {
      path: '/service/:serviceId/rss',
      name: 'ServiceRss',
      component: ServiceRss,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },
    // Dropbox設定
    {
      path: '/service/:serviceId/dropbox',
      name: 'ServiceDropbox',
      component: ServiceDropbox,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },

    // コンテンツ設定
    {
      path: '/service/:serviceId/contentsSetting',
      name: 'ServiceContentsSetting',
      component: ServiceContentsSetting,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },
    // コンテンツ設定 : 基本情報設定
    {
      path: '/service/:serviceId/contentsSetting/:serviceContentsId',
      component: ServiceContentsSettingForm,
      props: route => ({
        serviceId: route.params.serviceId,
        serviceContentsId: route.params.serviceContentsId
      }),
      meta: { requiresAuth: true },
      children: [
        // 入力
        {
          path: 'form',
          name: 'ServiceContentsSettingForm',
          component: ServiceContentsSettingInput
        }
      ]
    },
    // コンテンツ設定 : 画面別設定
    {
      path: '/service/:serviceId/contentsSetting/:serviceContentsId/screenSetting',
      name: 'ServiceScreenSetting',
      component: ServiceScreenSetting,
      props: route => ({
        serviceId: route.params.serviceId,
        serviceContentsId: route.params.serviceContentsId
      }),
      meta: { requiresAuth: true }
    },
    {
      path: '/service/:serviceId/contentsSetting/:serviceContentsId/screenSetting/:contentsScreenId',
      component: ServiceScreenSettingForm,
      props: route => ({
        serviceId: route.params.serviceId,
        serviceContentsId: route.params.serviceContentsId,
        contentsScreenId: route.params.contentsScreenId
      }),
      meta: { requiresAuth: true },
      children: [
        // 入力
        {
          path: 'form',
          name: 'ServiceScreenSettingForm',
          component: ServiceScreenSettingInput
        }
      ]
    },

    // コンテンツ適用
    {
      path: '/service/:serviceId/contentsApply',
      name: 'ServiceContentsApply',
      component: ServiceContentsApply,
      props: route => ({ serviceId: route.params.serviceId }),
      meta: { requiresAuth: true }
    },


    // ファイル一覧
    {
      path: '/file',
      name: 'File',
      component: File,
      meta: { requiresAuth: true }
    },

    // Bot一覧
    {
      path: '/bot',
      name: 'Bot',
      component: Bot,
      meta: { requiresAuth: true }
    },

    // 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
    // 外部連携パートナー一覧
    {
      path: '/partner',
      name: 'Partner',
      component: Partner,
      meta: {requiresAuth: true}
    },
    // 外部連携パートナー一覧登録・編集
    {
      path: '/partner/:partnerId',
      component: PartnerForm,
      props: route => ({partnerId: route.params.partnerId}),
      meta: {requiresAuth: true},
      children: [
        // 入力
        {
          path: 'form',
          name: 'PartnerForm',
          component: PartnerInput
        },
        // 確認
        {
          path: 'confirm',
          name: 'PartnerConfirm',
          component: PartnerConfirm
        }
      ]
    },
    // 202304 サービス管理に「外部パートナー連携」メニューを追加 ED



    // ---------------
    // マスタ管理
    // ---------------

    // 配信タイプマスタ
    {
      path: '/deliveryTypeMst',
      name: 'DeliveryTypeMst',
      component: DeliveryTypeMst,
      meta: { requiresAuth: true }
    },

    // お知らせタイプマスタ
    {
      path: '/noticeTypeMst',
      name: 'NoticeTypeMst',
      component: NoticeTypeMst,
      meta: { requiresAuth: true }
    },

    // 連携CMSマスタ
    {
      path: '/linkedCmsMst',
      name: 'LinkedCmsMst',
      component: LinkedCmsMst,
      meta: { requiresAuth: true }
    },

    // 画面構成マスタ
    {
      path: '/screenConfigMst',
      name: 'ScreenConfigMst',
      component: ScreenConfigMst,
      meta: { requiresAuth: true }
    },

    // 固定画面マスタ
    {
      path: '/screenIdMst',
      name: 'ScreenIdMst',
      component: ScreenIdMst,
      meta: { requiresAuth: true }
    },

    // スマホアプリマスタ
    {
      path: '/spAppMst',
      name: 'SpAppMst',
      component: SpAppMst,
      meta: { requiresAuth: true }
    },



    // ---------------
    // アカウント管理
    // ---------------
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: { requiresAuth: true }
    },
    {
      path: '/user/:userId',
      component: UserForm,
      props: route => ({ userId: route.params.userId }),
      meta: { requiresAuth: true },
      children: [
        // 入力
        {
          path: 'form',
          name: 'UserForm',
          component: UserInput
        },
        // 確認
        {
          path: 'confirm',
          name: 'UserConfirm',
          component: UserConfirm
        }
      ]
    },



    // ---------------
    // お知らせ管理
    // ---------------
    {
      path: '/notice',
      name: 'Notice',
      component: Notice,
      meta: { requiresAuth: true }
    },
    {
      path: '/notice/:noticeId',
      component: NoticeForm,
      props: route => ({
        noticeId: route.params.noticeId
      }),
      meta: { requiresAuth: true },
      children: [
        // お知らせタイプ選択
        {
          path: 'selector',
          name: 'NoticeSelector',
          component: NoticeSelector
        },
        // 入力
        {
          path: 'form',
          name: 'NoticeForm',
          component: NoticeInput
        },
        // 確認
        {
          path: 'confirm',
          name: 'NoticeConfirm',
          component: NoticeConfirm
        }
      ]
    },
    {
      path: '/notice/:noticeId/detail',
      name: 'NoticeDetail',
      component: NoticeDetail,
      props: route => ({
        noticeId: route.params.noticeId,
        listType: route.params.listType,
      }),
      meta: { requiresAuth: true }
    },



    // ---------------
    // お知らせ配信管理（Bot）    
    // ---------------
    {
      path: '/noticeList',
      name: 'NoticeList',
      component: Notice,
    },
    {
      path: '/noticeList/:noticeId/detail',
      name: 'NoticeListDetail',
      component: NoticeDetail,
      props: route => ({
        noticeId: route.params.noticeId,
        listType: route.params.listType,
      }),
    },



    // ---------------
    // ログ管理
    // ---------------
    {
      path: '/log',
      name: 'Log',
      component: Log,
      meta: { requiresAuth: true }
    },
    {
      path: '/log/download',
      name: 'LogDownload',
      component: LogDownload,
      meta: { requiresAuth: true }
    },



    // ---------------
    // ADMP管理
    // ---------------
    // テナント管理
    {
      path: '/tenant',
      name: 'Tenant',
      component: Tenant,
      meta: { requiresAuth: true }
    },
    {
      path: '/tenant/:tenantId/detail',
      name: 'TenantDetail',
      component: TenantDetail,
      props: route => ({ tenantId: route.params.tenantId }),
      meta: { requiresAuth: true }
    },
    // コミュニティ管理
    {
      path: '/community',
      name: 'Community',
      component: Community,
      meta: { requiresAuth: true }
    },
    {
      path: '/community/:communityId/detail',
      name: 'CommunityDetail',
      component: CommunityDetail,
      props: route => ({ communityId: route.params.communityId }),
      meta: { requiresAuth: true }
    },
    {
      path: '/community/:communityId/location/:locationId/detail',
      name: 'CommunityLocation',
      component: CommunityLocation,
      props: route => ({
        communityId: route.params.communityId,
        locationId: route.params.locationId
      }),
      meta: { requiresAuth: true }
    },
    // デバイス管理
    {
      path: '/device',
      name: 'Device',
      component: Device,
      meta: { requiresAuth: true }
    },



    // ---------------
    // ささえiでんわ管理
    // ---------------
    {
      path: '/videoChat',
      name: 'VideoChat',
      component: VideoChat,
      meta: { requiresAuth: true }
    },



    // ---------------
    // マイアカウント
    // ---------------
    {
      path: '/myAccount',
      name: 'MyAccount',
      component: MyAccount,
      meta: { requiresAuth: true }
    },



    // ---------------
    // ロケーション管理
    // ---------------
    {
      path: '/location',
      name: 'Location',
      component: Location,
      meta: { requiresAuth: true }
    },


    // ---------------
    // お知らせ配信管理
    // ---------------
    // {
    //   path: '/noticeList',
    //   name: 'NoticeCheck',
    //   component: NoticeCheck,
    // },



    // ---------------
    // Core
    // ---------------
    
    // // パスワード登録（新規ユーザー）
    // {
    //   path: '/register',
    //   component: Register,
    //   children: [
    //     // 入力
    //     {
    //       path: 'form',
    //       name: 'Register',
    //       component: RegisterInput
    //     },
    //     // 確認
    //     {
    //       path: 'confirm',
    //       name: 'RegisterConfirm',
    //       component: RegisterConfirm
    //     }
    //   ]
    // },
    // // パスワード変更（既存ユーザー）
    // {
    //   path: '/password',
    //   component: Password,
    //   children: [
    //     // 入力
    //     {
    //       path: 'form',
    //       name: 'Password',
    //       component: PasswordInput
    //     },
    //     // 確認
    //     {
    //       path: 'confirm',
    //       name: 'PasswordConfirm',
    //       component: PasswordConfirm
    //     }
    //   ]
    // },

    // セットアップ
    {
      path: '/setup',
      name: 'Setup',
      component: Setup
    },
    // 初期パスワード変更
    {
      path: '/setupPassword',
      name: 'SetupPassword',
      component: SetupPassword
    },
    // ログイン
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    // 二段階認証
    {
      path: '/verification',
      name: 'Verification',
      component: Verification
    },
    
    // 404
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '*',
      redirect: { name: 'Signin' }
    }
  ],
  // ページ遷移ごとにスクロールが上端に戻る挙動
  scrollBehavior (to, from, savedPosition) {
    return savedPosition ?
      savedPosition : { x: 0, y: 0 }

    // // アンカースクロールの場合
    // if (to.hash) {
    //   return {
    //     selector: to.hash,
    //     offset: { x: 0, y: 0 }
    //   }
    // }

    // // 非同期なスクローリング
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({ x: 0, y: 0 })
    //   }, 500)
    // })
  }
})

/* 認証していない場合にリダイレクト */
router.beforeEach((to, from, next) => {
  console.log('---------->> ', to.path)

  // 認証が必要なページが判別
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // ローカルストレージにユーザー情報が保持されているかチェック
  // 保持されていなければログインページにリダイレクト
  Constants.checkAuth()
    .then(routeName => {
      console.log(to.name, store.getters['permission/permittedView'](to.name));
      if (routeName) {
        if (store.getters['permission/permittedView'](routeName)) {
          next({ name: routeName })
        } else {
          next({ name: 'Home' })
        }
        
      } else {
        if (store.getters['permission/permittedView'](to.name)) {
          next()
        } else {
          next({ name: 'Home' })
        }
      }
    })
    .catch(() => {
      if (requiresAuth) {
        next({ name: 'Signin' })
      } else {
        next()
      }
    })
})

export default router
